export const SHOW_PLAYER = 'player::SHOW_PLAYER';
export const HIDE_PLAYER = 'player::HIDE_PLAYER';
export const SET_PLAYER = 'player::SET_PLAYER';

export const SET_PLAYER_SUBTITLES = 'player::SET_PLAYER_SUBTITLES';
export const SET_PLAYER_AUDIO = 'player::SET_PLAYER_AUDIO';
export const DELETE_PROFILE_PLAYER_SUBTITLES =
    'player::DELETE_PROFILE_PLAYER_SUBTITLES';
export const DELETE_PROFILE_PLAYER_AUDIO =
    'player::DELETE_PROFILE_PLAYER_AUDIO';

export const SET_GENERATE_ID = 'player::SET_GENERATE_ID';

export const SET_MODAL_PLAYER_FULLSCREEN =
    'player::SET_MODAL_PLAYER_FULLSCREEN';

export const SET_SPOTLIGHT_VIDEO_VISIBLE =
    'player::SET_SPOTLIGHT_VIDEO_VISIBLE';

export const SET_OTT_LAST_CONNECTION = 'player::SET_OTT_LAST_CONNECTION';
export const SET_LAST_PROVISION_DATE = 'player::SET_LAST_PROVISION_DATE';

export const SET_MUTED = 'player::SET_MUTED';

export const SET_VOLUME = 'player::SET_VOLUME';

export const SET_PLAYER_SUBTITLES_FONT_SIZE =
    'player::SET_PLAYER_SUBTITLES_FONT_SIZE';
export const DELETE_PLAYER_SUBTITLES_FONT_SIZE =
    'player::DELETE_PLAYER_SUBTITLES_FONT_SIZE';
